// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Loading-Loading-module__Loading";
var _2 = "webpack-components-core-Loading-Loading-module__LoadingSpinner";
var _3 = "webpack-components-core-Loading-Loading-module__brand";
var _4 = "webpack-components-core-Loading-Loading-module__lg";
var _5 = "webpack-components-core-Loading-Loading-module__md";
var _6 = "webpack-components-core-Loading-Loading-module__neutral";
var _7 = "webpack-components-core-Loading-Loading-module__primary";
var _8 = "webpack-components-core-Loading-Loading-module__sm";
var _9 = "webpack-components-core-Loading-Loading-module__spin-animation";
var _a = "webpack-components-core-Loading-Loading-module__xl";
var _b = "webpack-components-core-Loading-Loading-module__xs";
var _c = "webpack-components-core-Loading-Loading-module__xxl";
export { _1 as "Loading", _2 as "LoadingSpinner", _3 as "brand", _4 as "lg", _5 as "md", _6 as "neutral", _7 as "primary", _8 as "sm", _9 as "spin-animation", _a as "xl", _b as "xs", _c as "xxl" }
